import React, { useEffect, useState, useMemo } from "react";
import { Box } from "@mui/material";
import ImageWithLoader from "components/common/ImageWithLoader";
import styles from "./styles.module.scss";
import ZoomImageModal from "components/common/ZoomImageModal";

const StepImages = (props) => {
    const { steps } = props;
    const [showedStep, setShowedStep] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (!steps) return;
        let currentIndex = 0;
        steps.forEach((item, index) => {
            if (item.image && index > currentIndex) {
                currentIndex = index;
            }
        });
        setShowedStep(currentIndex);
    }, [steps]);

    // Move hook above any early return
    const cacheBustedSrc = useMemo(() => {
        const url = steps?.[showedStep]?.image;
        if (!url) return url;
        const sep = url.includes("?") ? "&" : "?";
        return `${url}${sep}t=${Date.now()}`;
    }, [steps, showedStep]);

    if (!steps || !steps[showedStep]) return null;

    return (
        <Box className={styles.stepImageContainer}>
            <Box
                className={styles.imageWrapper}
                onClick={() => setIsModalOpen(!isModalOpen)}
            >
                <ImageWithLoader
                    key={showedStep}
                    classNames={{
                        empty: styles.imgEmptyContainer,
                        main: styles.imageContainer,
                    }}
                    src={cacheBustedSrc}
                    emptyLabel={
                        <Box className={styles.emptyImgDescription}>
                            Not Scanned
                        </Box>
                    }
                />
            </Box>
            <ZoomImageModal
                isOpen={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                src={cacheBustedSrc}
                title={`Step ${showedStep + 1}`}
            />
        </Box>
    );
};

export default StepImages;
